<template>
  <div class="font-size-sm mb-2 pb-2 wc-mobile-order-panel">
    <WCOrderPanelHeader
      :order="order"
      @editOrder="editOrder"
      @cancelOrder="cancelOrder($event)"
      @receipt="$emit('receipt', order)"
      ref="orderPanelHeaderRef"
    />
    <WCMobileOrderPanelBody
      :order="order"
      @addToCart="addToCart"
      @replaceCart="replaceCart"
      @replaceReceipt="replaceReceipt"
    />
  </div>
</template>

<script>
import OrderPanelMixin from '@/modules/orders/mixins/OrderPanelMixin';
import WCOrderPanelHeader from '@/modules/orders/components/WCOrderPanel/WCOrderPanelHeader.vue';
import WCMobileOrderPanelBody from '@/modules/orders/components/WCMobileOrderPanel/WCMobileOrderPanelBody.vue';

export default {
  components: {
    WCOrderPanelHeader,
    WCMobileOrderPanelBody,
  },
  mixins: [OrderPanelMixin],
  methods: {
    addToCart(order) {
      console.log('addToCart', order);
    },
    replaceCart(order) {
      console.log('replaceCart', order);
    },
    replaceReceipt(order) {
      console.log('replaceReceipt', order);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-item-image {
  width: rem(50px);
  height: rem(50px);
  object-fit: scale-down;
}

.wc-mobile-order-panel {
  border-bottom: 8px solid var(--secondary-lighter-9, #f8f9fa);
}
</style>
